import i18next from "translations/i18n";

i18next.addResourceBundle(
  "de",
  "funnel",
  {
    normal: "Normal",
    big: "Groß",
    ceramic: "Glaskeramik",
    induction: "Induktion",
    gas: "Gas",
    high: "Höhe",
    wide: "breit",

    of: "Von",
    or: "oder",
    skip: "Überspringen",
    back: "Zurück",
    next: "Weiter",
    wait: "Bitte warten...",
    tocheckout: "Zum Kosten-Check",

    "stepconditions-h1": "Weshalb benötigst du eine Küche?",
    "stepconditions-newbuild": "Neubau",
    "stepconditions-moving": "Umzug",
    "stepconditions-remodeling": "Austausch",
    "stepconditions-other": "Anderer Grund",

    "stepphase-h1": "In welcher Phase befindest du dich?",
    "stepphase-compare": "Ich möchte nur vergleichen",
    "stepphase-details": "Ich benötige Hilfe bei Details",
    "stepphase-inspiration": "Ich brauche Inspiration",

    "stepform-h1": "Welche Form soll deine Küche haben?",
    "stepform-island-h1": "Welche Inselküche möchtest du?",
    "stepform-einzeilig": "Einzeilig",
    "stepform-zweizeilig": "Zwei-Zeilig",
    "stepform-lform": "L-Form",
    "stepform-insel": "Mit Insel",
    "stepform-insel-linsel": "L-Insel",
    "stepform-insel-uinsel": "U-Insel",
    "stepform-insel-zeileninsel": "Zeilen-Insel",
    "stepform-insel-keineahnung": "Unschlüssig",
    "stepform-uform": "U-Form",
    "stepform-keineahnung": "Unschlüssig",

    "stephob-h1": "Wo soll das Kochfeld sein?",
    "stephob-onisland": "Auf der Insel",
    "stephob-onwall": "Auf der Zeile",

    "steppaint-h1": "Welche Farbe soll deine Küche haben?",
    "steppaint-dark": "Dunkel",
    "steppaint-bright": "Hell",
    "steppaint-colorful": "Farbig",

    "stepsurface-h1": "Welche Oberfläche soll deine Küche haben?",
    "stepsurface-matt": "Matt",
    "stepsurface-gloss": "Glänzend",

    "stepworktop-h1": "Welche Arbeitsplatte möchtest du?",
    "stepworktop-stone": "Stein",
    "stepworktop-stone-h1": "Welche Stein-Arbeitsplatte möchtest du?",
    "stepworktop-stone-laminate": "Steindekor",
    "stepworktop-stone-real": "Naturstein",
    "stepworktop-timber": "Holz",
    "stepworktop-timber-h1": "Welche Holz-Arbeitsplatte möchtest du?",
    "stepworktop-timber-laminate": "Holzdekor",
    "stepworktop-timber-real": "Echtholz",
    "stepworktop-color": "Einfarbig",
    "stepworktop-glass": "Glas",
    "stepworktop-concrete": "Beton",
    "stepworktop-notsure": "Keine Ahnung",

    "stepdevices-h1": "Benötigst du E-Geräte?",
    "stepdevices-h1-own": "Welche eigenen E-Geräte möchtest du verwenden?",
    "stepdevices-oven-h1": "Welchen Backofen-Typ benötigst du?",
    "stepdevices-oven-h1-own": "Welchen Backofen-Typ hast du?",
    "stepdevices-oven": "Backofen/Herd",
    "stepdevices-oven-own": "Eigener Backofen/Herd",
    "stepdevices-oven-base": "Unterbau",
    "stepdevices-oven-raised": "Brusthöhe",
    "stepdevices-hob": "Kochfeld",
    "stepdevices-hob-own": "Eigenes Kochfeld",
    "stepdevices-hob-h1": "Welchen Kochfeld-Typ benötigst du?",
    // "stepdevices-hob-h1-own": "Which type of hob do you own?",
    "stepdevices-dishwasher": "Geschirrspüler",
    "stepdevices-dishwasher-own": "Eigener Geschirrspüler",
    "stepdevices-fridge": "Kühlschrank",
    "stepdevices-fridge-own": "Eigener Kühlschrank",
    "stepdevices-fridge-h1": "Welchen Kühlschrank-Typ benötigst du?",
    "stepdevices-fridge-h1-own": "Welchen Kühlschrank-Typ hast du?",
    "stepdevices-fridge-builtin": "Einbau",
    "stepdevices-fridge-detached": "Freistehend",
    "stepdevices-fridge-small": "Kleiner",
    "stepdevices-fridge-normal": "Normaler",
    "stepdevices-fridge-sbs": "Side-by-Side",
    "stepdevices-hood": "Dunstabzug",
    "stepdevices-hood-own": "Eigener Dunstabzug",
    "stepdevices-hood-h1": "Welche Dunstabzugshaube möchtest du?",
    "stepdevices-hood-h1-own": "Welche Dunstabzugshaube hast du?",
    "stepdevices-hood-undercabinet": "Flachschirm",
    "stepdevices-hood-wallmounted": "Wandhaube",
    "stepdevices-hood-tiltedwall": "Kopffreihaube",
    "stepdevices-hood-island": "Inselhaube",
    "stepdevices-hood-downdraft": "Tischhaube",
    "stepdevices-hood-notsure": "Keine Ahnung",
    "stepdevices-washingmachine-own": "Eigene Waschmaschine",
    "stepdevices-microwave": "Mikrowelle",
    "stepdevices-wine-fridge": "Weinkühlschrank",
    "stepdevices-steam-cooker": "Dampfgarer",
    "stepdevices-coffee-machine": "Kaffeevollautomat",

    "show-more": "Mehr",

    "stepdevicebrands-h1": "Welche E-Geräte Marken möchtest du?",
    "stepdevicebrands-level1": "Einstiegs E-Geräte",
    "stepdevicebrands-level2": "Beliebteste E-Geräte",
    "stepdevicebrands-level3": "Premium E-Geräte",
    "stepdevicebrands-anyentrybrand": "Beliebige<br />Einstiegs-<br />Marke",
    "stepdevicebrands-anypopular": "Beliebige<br />beliebteste<br />Marke",
    "stepdevicebrands-otherfavourite": "Hast du andere Lieblingsmarken?",
    "stepdevicebrands-examples": "Marke 1, Marke 2,...",

    "stepdelivery-h1": "Wann möchtest du deine Küche kaufen?",
    "stepdelivery-lt1": "< 1 Monat",
    "stepdelivery-12": "1-2 Monate",
    "stepdelivery-24": "2-4 Monate",
    "stepdelivery-gt4": "> 4 Monate",

    "stepbudget-h1": "Um dich perfekt zu beraten, benötigen wir dein Budget",
    "stepbudget-typein": "Gib dein budget an",
    "stepbudget-installments": "Ich möchte gern in Raten zahlen",
    "stepbudget-info-h": "Wichtige Hinweise:",
    "stepbudget-info-partner": "Die lokalen Partner erhalten diese Information nicht!",
    "stepbudget-info-pic": "Die Bilder dienen nur als Beispiel und stellen keinen realistischen Kaufpreis dar.",

    "stepuploads-h1": "Rauminformationen hochladen",
    "stepuploads-more": "Weitere Dateien hochladen",
    "stepuploads-descplaceholder": "Gib hier deine Maße und Wünsche ein...",
    "stepuploads-info":
      "Lade relevante Dateien deines Küchenraumes hoch, schicke uns Angebote von Küchenhändlern oder zeichne deinen eigenen Grundriss. (Formate: .jpg, .png, .pdf)",
    "stepuploads-button-upload": "Dateien Hochladen",
    "stepuploads-button-draw": "Grundriss Zeichnen",

    "steppersonal-h1": "Dein persönlicher Kosten-Check",
    "steppersonal-gender": "Anrede",
    "steppersonal-male": "Herr",
    "steppersonal-female": "Frau",
    "steppersonal-firstName": "Vorname",
    "steppersonal-lastName": "Name",
    "steppersonal-phone": "Telefon",
    "steppersonal-zip": "PLZ",
    "steppersonal-files": "Angehängte Dateien",
    "steppersonal-email": "E-Mail",
    "steppersonal-comment": "Anmerkung",
    "steppersonal-error": "Please enter correct data",
    "steppersonal-didyoumean": "Meintest du",
    "steppersonal-reviews-h1": "Unsere glücklichen Kunden sprechen für sich",

    "constraints-email-add": "Bitte gib deine E-Mail Adresse an.",
    "constraints-email-fix": "Bitte gib eine gültige E-Mail Adresse an.",
    "constraints-firstName": "Bitte gib deinen Vornamen an.",
    "constraints-lastName": "Bitte gib deinen Nachnamen an.",
    "constraints-phone": "Bitte gib eine gültige Telefonnummer an.",
    "constraints-zip-add": "Bitte gib deine Postleitzahl an.",
    "constraints-zip-fix": "Bitte gib eine gültige Postleitzahl an.",
  },

  true,
  true
);

i18next.addResourceBundle(
  "en",
  "funnel",
  {
    normal: "Normal",
    big: "Big",
    ceramic: "Ceramic",
    induction: "Induction",
    gas: "Gas",
    high: "high",
    wide: "wide",

    of: "Of",
    or: "or",
    skip: "Skip",
    back: "Back",
    next: "Next",
    wait: "Please wait...",
    tocheckout: "Submit",
    "stepconditions-h1": "Why do you need a kitchen?",
    "stepconditions-newbuild": "New Build",
    "stepconditions-moving": "Moving",
    "stepconditions-remodeling": "Remodeling",
    "stepconditions-other": "Other Reason",
    "stepphase-h1": "Which phase are you currently in?",
    "stepphase-compare": "Just comparing",
    "stepphase-details": "I need assistance with details",
    "stepphase-inspiration": "I need inspiration",

    "stepform-h1": "Which form should your kitchen have?",
    "stepform-island-h1": "Which type of island kitchen would you like?",
    "stepform-einzeilig": "One-wall kitchen",
    "stepform-zweizeilig": "Galley kitchen",
    "stepform-lform": "L-Shape",
    "stepform-insel": "Island kitchen",
    "stepform-insel-linsel": "L-Island",
    "stepform-insel-uinsel": "U-Island",
    "stepform-insel-zeileninsel": "One-wall island",
    "stepform-insel-keineahnung": "Not sure",
    "stepform-uform": "U-Shape",
    "stepform-keineahnung": "Not sure",

    "stephob-h1": "Where should the hob be placed?",
    "stephob-onisland": "On the island",
    "stephob-onwall": "On the wall",

    "steppaint-h1": "Which color should your kitchen have?",
    "steppaint-dark": "Dark",
    "steppaint-bright": "Bright",
    "steppaint-colorful": "Colorful",

    "stepsurface-h1": "Which surface type should your kitchen have?",
    "stepsurface-matt": "Matt",
    "stepsurface-gloss": "Gloss",

    "stepworktop-h1": "Which worktop would you like?",
    "stepworktop-stone": "Stone",
    "stepworktop-stone-h1": "Which type of stone worktop would you like to have?",
    "stepworktop-stone-laminate": "Stone laminate",
    "stepworktop-stone-real": "Real stone",
    "stepworktop-timber": "Timber",
    "stepworktop-timber-h1": "Which timber worktop would you like to have?",
    "stepworktop-timber-laminate": "Timber laminate",
    "stepworktop-timber-real": "Real timber",
    "stepworktop-color": "Simple Color",
    "stepworktop-glass": "Glass",
    "stepworktop-concrete": "Concrete",
    "stepworktop-notsure": "Not sure",

    "stepdevices-h1": "Do you need appliances?",
    "stepdevices-h1-own": "Which of your own appliances would you like to use?",
    "stepdevices-oven-h1": "Which type of oven would you like?",
    "stepdevices-oven-h1-own": "Which type of oven do you own?",
    "stepdevices-oven": "Oven",
    "stepdevices-oven-own": "Own oven",
    "stepdevices-oven-base": "Base oven",
    "stepdevices-oven-raised": "Raised oven",
    "stepdevices-hob": "Cooker Hob",
    "stepdevices-hob-own": "Own cooker hob",
    "stepdevices-hob-h1": "Which type of hob would you like?",
    // "stepdevices-hob-h1-own": "Which type of hob do you own?",
    "stepdevices-dishwasher": "Dishwasher",
    "stepdevices-dishwasher-own": "Own dishwasher",
    "stepdevices-fridge": "Fridge",
    "stepdevices-fridge-own": "Own fridge",
    "stepdevices-fridge-h1": "Which type of fridge would you like?",
    "stepdevices-fridge-h1-own": "Which type of fridge do you own?",
    "stepdevices-fridge-builtin": "Built-in",
    "stepdevices-fridge-detached": "Detached",
    "stepdevices-fridge-small": "Small",
    "stepdevices-fridge-normal": "Normal",
    "stepdevices-fridge-sbs": "Side-By-Side",
    "stepdevices-hood": "Exhaust hood",
    "stepdevices-hood-own": "Own exhaust hood",
    "stepdevices-hood-h1": "Which type of hood would you like?",
    "stepdevices-hood-h1-own": "Which type of hood do you own?",
    "stepdevices-hood-undercabinet": "Under-Cabinet",
    "stepdevices-hood-wallmounted": "Wall-Mounted",
    "stepdevices-hood-tiltedwall": "Tilted wall hood",
    "stepdevices-hood-island": "Island Hood",
    "stepdevices-hood-downdraft": "Downdraft",
    "stepdevices-hood-notsure": "Not sure",
    "stepdevices-washingmachine-own": "Own washing machine",
    "stepdevices-microwave": "Microwave",
    "stepdevices-wine-fridge": "Wine fridge",
    "stepdevices-steam-cooker": "Steam cooker",
    "stepdevices-coffee-machine": "Coffee machine",

    "show-more": "Show more",

    "stepdevicebrands-h1": "Which appliance brand would you like to get?",
    "stepdevicebrands-level1": "Entry-level",
    "stepdevicebrands-level2": "Most popular",
    "stepdevicebrands-level3": "Premium",
    "stepdevicebrands-anyentrybrand": "Any<br />Entry<br />Brand",
    "stepdevicebrands-anypopular": "Any<br />Popular<br />Brand",
    "stepdevicebrands-otherfavourite": "Other favorite brands?",
    "stepdevicebrands-examples": "Brand 1, Brand 2, ...",

    "stepdelivery-h1": "When would you like to buy your kitchen?",
    "stepdelivery-lt1": "< 1 month",
    "stepdelivery-12": "1-2 months",
    "stepdelivery-24": "2-4 months",
    "stepdelivery-gt4": "> 4 months",

    "stepbudget-h1": "What is your budget?",
    "stepbudget-typein": "type budget",
    "stepbudget-installments": "I would like to pay in installments",
    "stepbudget-info-h": "Important note:",
    "stepbudget-info-partner": "Our partners will not get your budget information!",
    "stepbudget-info-pic": "The pictures are only examples and do not represent a realistic purchase price.",

    "stepuploads-h1": "Upload your room dimensions",
    "stepuploads-more": "Upload more files",
    "stepuploads-descplaceholder": "Enter here your measurements and wishes...",
    "stepuploads-info":
      "Upload all relevant files of your kitchen room, send us offers of other retailers you’ve visited or draw your floorplan (Accepted formats: .jpg, .png, .pdf)",
    "stepuploads-button-upload": "Upload files",
    "stepuploads-button-draw": "Draw floorplan",

    "steppersonal-h1": "Get your kitchen planned by an expert",
    "steppersonal-gender": "Gender",
    "steppersonal-male": "Male",
    "steppersonal-female": "Female",
    "steppersonal-firstName": "First Name",
    "steppersonal-lastName": "Last Name",
    "steppersonal-phone": "Phone Number",
    "steppersonal-zip": "Postal Code",
    "steppersonal-files": "Attached files",
    "steppersonal-email": "E-Mail",
    "steppersonal-comment": "Comment",
    "steppersonal-error": "Please enter correct data",
    "steppersonal-didyoumean": "Did you mean",
    "steppersonal-reviews-h1": "Our happy customers speak for themselves",

    "constraints-email-add": "Please enter correct data",
    "constraints-email-fix": "Please enter correct data",
    "constraints-firstName": "Please enter correct data",
    "constraints-lastName": "Please enter correct data",
    "constraints-phone": "Please enter correct data",
    "constraints-zip-add": "Please enter correct data",
    "constraints-zip-fix": "Please enter correct data",
  },
  true,
  true
);
